import React from 'react';
import { TeamNameCategory } from '../../../services/central-api/dispatch';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { UseFormReturn } from 'react-hook-form';
import FormDropDownPicker from '../../../components/FormDropDownPicker';

type Props = {
    zIndex: number;
    disabled?: boolean;
    required?: boolean;
    emptyOption?: boolean;
} & ({
    form?: undefined;
    fieldName?: undefined;
    value: TeamNameCategory;
    setValue: (value: TeamNameCategory | null) => void;
} | {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    form: UseFormReturn<any, any, any>;
    fieldName: string;
    value?: undefined;
    setValue?: undefined;
});

function CategoriesDropdown({ value, setValue, zIndex, disabled, form, fieldName, required, emptyOption }: Props) {
    const items = Object.values(TeamNameCategory).map((item: string) => {
        return {
            label: item ? translate(item) : '', value: item
        };
    });

    if (emptyOption) {
        items.unshift({ label: '', value: '' });
    }

    if (form && fieldName) {
        return <FormDropDownPicker
            label={translate('category')}
            items={items}
            multiple={false}
            zIndex={zIndex}
            disabled={disabled}
            required={required}
            fieldName={fieldName}
            form={form}
        />;
    } else if (value !== undefined && setValue !== undefined) {

        return (
            <FilterDropdown
                label={translate('category')}
                items={items}
                multiple={false}
                setValue={(selectedValue) => {
                    const selectedCategory = selectedValue(value);
                    setValue(selectedCategory == value ? '' : selectedCategory);
                }}
                value={value}
                zIndex={zIndex}
                disabled={disabled}
                required={required}
            />
        );
    }
}

export default CategoriesDropdown;
